import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useAtom, useSetAtom, useAtomValue } from 'jotai';
import {
  openAddInfoFormRanDb,
  openUploadFileRanDb,
  openUploadFormRanDb,
  ranDbViewMode,
  selectedRanDbRow,
} from '../../common/atom/atoms';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuditLogsPopup } from './audit_logs_popup.component';

export const RanDBHeader = ({ siteCode = null }) => {
  const setOpenAddInfoUploadForm = useSetAtom(openAddInfoFormRanDb);
  const [viewMode, setViewMode] = useAtom(ranDbViewMode);
  const navigate = useNavigate();
  const [openUploadFile, setOpenUploadFile] = useAtom(openUploadFileRanDb);
  const selectedRow = useAtomValue(selectedRanDbRow);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [auditLogsOpen, setAuditLogsOpen] = useState(false);

  // Use siteCode prop if provided, otherwise try to get from selected row
  const currentSiteCode = siteCode || selectedRow?.site_code;

  const handleChange = (_, newValue) => {
    if (newValue !== null) {
      setViewMode(newValue);
      // Data fetching is handled by the main component's useEffect
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddSingleFile = () => {
    setOpenAddInfoUploadForm(true);
    handleClose();
  };
  const handleUploadFile = () => {
    setOpenUploadFile(true);
    handleClose();
  };

  // Set default last update
  useEffect(() => {
    setLastUpdate({
      timestamp: new Date(),
      user: 'System',
    });
  }, []);

  const handleAuditLogsClick = () => {
    setAuditLogsOpen(true);
  };

  const formatLastUpdate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  return (
    <>
      <AuditLogsPopup
        open={auditLogsOpen}
        onClose={() => setAuditLogsOpen(false)}
        siteCode={currentSiteCode}
      />
      <div
        style={{
          width: '100%',
          padding: '0px 2%',
          backgroundColor: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div
              style={{
                padding: 8,
                background: '#f7f7f7',
                boxShadow: '0px 0px 30px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: 8,
                height: 30,
                width: 30,
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onClick={() => navigate('/rov')}
            >
              <ArrowBackIosNewIcon style={{ fontSize: 18, color: '#1C274C' }} />
            </div>
            <div style={{ color: 'black', fontSize: 20, fontWeight: '500' }}>RAN db</div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleChange}
            sx={{
              background: '#F8E8E9',
              borderRadius: '8px',
              padding: '4px',
              marginTop: '10px',
              marginBottom: '8px',
              gap: '8px',
              width: 'fit-content',
              '& .MuiToggleButtonGroup-grouped': {
                border: 'none',
                textTransform: 'none',
                fontSize: 14,
                fontFamily: 'Roboto',
                fontWeight: 500,
                borderRadius: '6px !important',
                padding: '7px 11px',
                color: '#192126',
                backgroundColor: 'transparent',
                '&.Mui-selected': {
                  backgroundColor: '#BD1D23',
                  color: '#F8E8E9',
                  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.10)',
                },
                '&:hover': {
                  backgroundColor: '#D79B9D',
                  color: '#F8E8E9',
                },
              },
            }}
          >
            <ToggleButton value="overview">Overview</ToggleButton>
            <ToggleButton value="detailed">Detailed</ToggleButton>
            <ToggleButton value="archived">Archived</ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div>
    </>
  );
};
